import { colors } from '@apollo/brand';

/**
 * Mermaid requires the use of actual hex values vs css variables since they handle calculating values internally for some styles.
 * Because of that, we will need to use the direct tokens and keep the themes separate.
 */

const { bg, border, text, flowchart } = colors.tokens;

const themeLight = {
  darkMode: false,
  background: bg.primary.base,
  arrowheadColor: flowchart.d.base,
  primaryColor: bg.primary.base,
  primaryTextColor: text.primary.base,
  secondaryColor: bg.primary.base,
  primaryBorderColor: border.primary.base,
  secondaryBorderColor: border.primary.base,
  secondaryTextColor: text.primary.base,
  tertiaryColor: bg.primary.base,
  tertiaryBorderColor: border.primary.base,
  tertiaryTextColor: text.primary.base,
  noteBkgColor: bg.neutral.base,
  noteTextColor: text.neutral.base,
  noteBorderColor: border.neutral.base,
  lineColor: flowchart.d.base,
  textColor: text.primary.base,
  mainBkg: bg.primary.base,
  errorBkgColor: bg.error.base,
  errorTextColor: text.error.base,
  nodeBorder: flowchart.b.base,
  clusterBkg: bg.primary.base,
  clusterBorder: flowchart.c.base,
  defaultLinkColor: flowchart.d.base,
  titleColor: flowchart.text.base,
  edgeLabelBackground: bg.primary.base,
  nodeTextColor: flowchart.text.base,
};

const themeDark = {
  darkMode: true,
  background: bg.primary.dark,
  arrowheadColor: flowchart.d.dark,
  primaryColor: bg.primary.dark,
  primaryTextColor: text.primary.dark,
  secondaryColor: bg.primary.dark,
  primaryBorderColor: border.primary.dark,
  secondaryBorderColor: border.primary.dark,
  secondaryTextColor: text.primary.dark,
  tertiaryColor: bg.primary.dark,
  tertiaryBorderColor: border.primary.dark,
  tertiaryTextColor: text.primary.dark,
  noteBkgColor: bg.neutral.dark,
  noteTextColor: text.neutral.dark,
  noteBorderColor: border.neutral.dark,
  lineColor: flowchart.d.dark,
  textColor: text.primary.dark,
  mainBkg: bg.primary.dark,
  errorBkgColor: bg.error.dark,
  errorTextColor: text.error.dark,
  nodeBorder: flowchart.b.dark,
  clusterBkg: bg.primary.dark,
  clusterBorder: flowchart.c.dark,
  defaultLinkColor: flowchart.d.dark,
  titleColor: flowchart.text.dark,
  edgeLabelBackground: bg.primary.dark,
  nodeTextColor: flowchart.text.dark,
};

const mermaidTheme = (theme: typeof themeLight | typeof themeDark) => ({
  ...theme,
  fontFamily: 'var(--font-mono)',
});

export const mermaidLightTheme = mermaidTheme(themeLight);
export const mermaidDarkTheme = mermaidTheme(themeDark);
